import { useState } from 'react'
import { Badge, Button, Group, Paper, Stack, Text, Title } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { useRTEmpresaReenviarAceite, useRTsEmpresaList } from '../../hooks/useRTsEmpresa'
import { extractApiError } from '../../lib/extractApiError'
import type { Empresa } from '../../hooks/useEmpresas'
import type { RTEmpresa } from '../../types'
import RTEmpresaModal from './RTEmpresaModal'

export default function RTsEmpresaSection({ empresa }: { empresa: Empresa }) {
  const [aberto, setAberto] = useState(false)
  const [rtEmEdicao, setRtEmEdicao] = useState<RTEmpresa | null>(null)
  const rts = useRTsEmpresaList({ empresa: empresa.id, page_size: 100 })
  const reenviar = useRTEmpresaReenviarAceite()

  async function enviarTermo(id: string) {
    try {
      const resultado = await reenviar.mutateAsync(id)
      notifications.show({ color: 'green', message: `Termo enviado para ${resultado.email}.` })
    } catch (err) {
      notifications.show({
        color: 'red',
        message: extractApiError(err, 'Não foi possível enviar o termo de aceite.'),
      })
    }
  }

  return (
    <Paper p="lg" withBorder mb="md">
      <Group justify="space-between" mb="sm">
        <div>
          <Title order={4}>Responsáveis técnicos</Title>
          <Text size="xs" c="dimmed">Profissionais que poderão ser escolhidos nos PMOCs desta empresa.</Text>
        </div>
        <Button
          size="xs"
          onClick={() => {
            setRtEmEdicao(null)
            setAberto(true)
          }}
        >
          + Novo RT
        </Button>
      </Group>
      <Stack gap="xs">
        {rts.isLoading ? (
          <Text c="dimmed">Carregando...</Text>
        ) : (rts.data?.results.length ?? 0) === 0 ? (
          <Text c="dimmed">Nenhum RT vinculado.</Text>
        ) : (
          rts.data?.results.map((rt) => (
            <Group key={rt.id} justify="space-between">
              <div>
                <Text fw={600}>{rt.nome}</Text>
                <Text size="xs" c="dimmed">{rt.conselho}-{rt.uf} {rt.numero_registro}</Text>
              </div>
              <Group gap="xs">
                <Badge color={rt.aceite_em ? 'green' : 'orange'} variant="light">
                  {rt.aceite_em ? 'Cadastro confirmado' : 'Aceite pendente'}
                </Badge>
                {rt.is_principal && <Badge variant="light">Principal</Badge>}
                <Button
                  size="compact-xs"
                  variant="subtle"
                  onClick={() => {
                    setRtEmEdicao(rt)
                    setAberto(true)
                  }}
                >
                  Editar
                </Button>
                {!rt.aceite_em && (
                  <Button size="compact-xs" variant="subtle" loading={reenviar.isPending} onClick={() => enviarTermo(rt.id)}>
                    Enviar termo
                  </Button>
                )}
              </Group>
            </Group>
          ))
        )}
      </Stack>
      <RTEmpresaModal
        opened={aberto}
        onClose={() => {
          setAberto(false)
          setRtEmEdicao(null)
        }}
        empresaId={empresa.id}
        empresaNome={empresa.razao_social}
        emailSugerido={empresa.email}
        rt={rtEmEdicao}
      />
    </Paper>
  )
}
